import React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import { AuxiliaryOverviewEngine } from "../../component/auxiliaryOverviewEngine/overviewEngine";

import { FristenInitialiser } from "./dataProvider";
import {
	closeFristenMiddleware,
	commitFristMiddleware,
	modifyUpdatedOverviewDocument,
	prefillWiedervorlageBeschreibungFristMiddleware
} from "./middlewares";
import { fristenSagas } from "./sagas";

const fristenModule = (): Module => ({
	id: "fristenModule",
	views: () => viewComponentProvider,
	sagas: () => fristenSagas,
	dataProviders: () => [FristenInitialiser],
	middlewares: () => [
		closeFristenMiddleware,
		modifyUpdatedOverviewDocument,
		commitFristMiddleware,
		prefillWiedervorlageBeschreibungFristMiddleware
	]
});

const components: { [name: string]: React.ComponentType<View> | undefined } = {
	FristenOverviewEngine: AuxiliaryOverviewEngine
};

function viewComponentProvider(name: string) {
	return components[name];
}

export default fristenModule;
